import { LoadingButton, LoadingButtonProps } from "@mui/lab";

const Button = ({
  size,
  loading = false,
  className,
  color,
  children,
  variant = "contained",
  onClick,
  disabled,
  loadingPosition,
  endIcon,
  startIcon,
  style,
  fullWidth = false,
  sx,
}: LoadingButtonProps) => {
  const effectiveLoadingPosition =
    loadingPosition ?? (startIcon ? "start" : endIcon ? "end" : "center");
  return (
    <LoadingButton
      centerRipple={true}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      loadingPosition={effectiveLoadingPosition}
      variant={variant}
      className={className}
      fullWidth={fullWidth}
      size={size}
      color={color}
      sx={{ textTransform: "none", fontFamily: "Google Sans", ...sx }}
      endIcon={endIcon}
      startIcon={startIcon}
      style={{
        borderWidth: "1px",
        padding: "8px 16px",
        ...style,
      }}
    >
      {children}
    </LoadingButton>
  );
};

export default Button;
